import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_TITLE = 'Supremics - Your Ultimate Web Comic Destination';
const DEFAULT_DESCRIPTION = 'Discover, read, and create amazing web comics. Join our community of passionate creators and readers. AI-powered tools, weekly prizes, and premium features.';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?w=1200';
const SITE_NAME = 'Supremics';
const BASE_URL = window.location.origin;

export function SEO({ 
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  author,
  publishedTime,
  tags = [],
  noIndex = false
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const fullUrl = url ? `${BASE_URL}${url}` : window.location.href;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Article specific (for blog posts) */}
      {type === 'article' && author && (
        <meta property="article:author" content={author} />
      )}
      {type === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {type === 'article' && tags.length > 0 && 
        tags.map((tag, i) => (
          <meta key={i} property="article:tag" content={tag} />
        ))
      }
      
      {/* Keywords */}
      <meta name="keywords" content="web comics, manga, webtoon, online comics, comic creators, AI comics, digital comics, read comics online, create comics" />
      
      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Additional SEO */}
      <meta name="author" content={author || SITE_NAME} />
      <meta name="theme-color" content="#E63946" />
    </Helmet>
  );
}

export default SEO;
